export default class FormHelper {
    public static async setValidation(validationState) {
        if (validationState) {
            for (var field in validationState) {
                let control = document.getElementsByName(field)[0];
                if (control) {
                    control.classList.add("input-validation-error");
                }
            }
        }
    }

    public static resetValidation() {
        let inputs = document.getElementsByClassName("input-validation-error");
        for (let i = 0; i < inputs.length; i++) {
            inputs[i].classList.remove("input-validation-error");
        }
    }
}